<script>
import { mapActions, mapState } from 'vuex';
import TwConfirmDialog from '../components/TwConfirmDialog';
import TwOverlay from '../components/TwOverlay';
import RequestsList from '../components/requests/RequestsList';
import RequestsControl from '../components/requests/RequestsControl';
import RequestLogFileList from '../components/requests/RequestLogFileList';
import RequestListPagination from '../components/requests/RequestListPagination';

export default {
  name: 'Requests',
  components: {
    RequestListPagination,
    RequestLogFileList,
    TwConfirmDialog,
    TwOverlay,
    RequestsList,
    RequestsControl,
  },
  methods: {
    ...mapActions({
      initiateSetup: 'requestStatus/initiateSetup',
      setBreadcrumbs: 'nav/setBreadcrumbs',
    }),
  },
  computed: {
    ...mapState({
      requestLogFilesList: state => state.requestStatus.requestLogFilesList,
      requests: state => state.requestStatus.requests,
      filter: state => state.requestStatus.filter,
    }),
  },
  created() {
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: this.$t('menu.requests.pages.requests'), to: '', disabled: true },
      ],
      title: this.$t('menu.requests.title'),
    });
  },
  mounted() {
    this.initiateSetup();
  },
};
</script>

<template>
  <v-flex xs-12 requests>
    <v-progress-circular
      class="requests__loading"
      v-if="filter.loading"
      indeterminate
    />
    <tw-overlay :visible="filter.loading"></tw-overlay>
    <requests-control
      :load-new-page="filter.loadNewPage"
      :channels="requests.channels"
      :request-types="requests.requestTypes"
    />
    <requests-list/>
    <request-log-file-list :show="requestLogFilesList.show"/>
    <request-list-pagination :pagination-index="filter.paginationIndex"/>
  </v-flex>
</template>

<style lang="scss">
  .requests {
    position: relative;
    min-height: 300px;

    &__loading {
      position: absolute;
      top: 150px;
      left: 50%;
      z-index: 20;
      transform: translateX(-50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Requests.vue